export const colorsTheme = {
    base1: "#EFFCFF",
    base2 : "#4CAF50",
    warning: "#f44336"
}

export const meses = [
    "Seleccione","Enero","Febrero","Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];